export default __webpack_public_path__ + "849977a.png";